// API 설정
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://poopbook-backend.jaewonseo.workers.dev';

export const apiConfig = {
  baseURL: API_BASE_URL,
  endpoints: {
    userInfo: `${API_BASE_URL}/__user_info__`,
    posts: `${API_BASE_URL}/api/posts`,
    checkDailyPost: `${API_BASE_URL}/api/check-daily-post`,
    likedPosts: `${API_BASE_URL}/api/user/liked-posts`,
    uploadUrl: `${API_BASE_URL}/api/upload-url`,
    search: `${API_BASE_URL}/api/search`,
    post: (id: number) => `${API_BASE_URL}/api/posts/${id}`,
    postLike: (id: number) => `${API_BASE_URL}/api/posts/${id}/like`,
    postComments: (id: number) => `${API_BASE_URL}/api/posts/${id}/comments`,
    postShare: (id: number) => `${API_BASE_URL}/api/posts/${id}/share`,
    comment: (id: number) => `${API_BASE_URL}/api/comments/${id}`,
  }
};
